import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";

const FAQS = [
  {
    q: "How does the live configurator work?",
    a: "The configurator above renders premium SVG mockups of a kitchen and a wardrobe. Every swatch, preset and finish updates the scene instantly — no page reloads, no waiting. When you're happy, save the design or submit it to us and we'll build a real 3D walkthrough.",
  },
  {
    q: "Is the configurator just visual, or is it the real material we use?",
    a: "Every swatch matches a real material in our studio — Carrara marble, walnut crema veneers, brushed brass hardware, German laminates. Once you submit a design, our consultant brings physical samples that exactly match what you saw on screen.",
  },
  {
    q: "What does a Design Decor project usually cost?",
    a: "Modular kitchens start at ₹3.5L, wardrobes at ₹85k, and turnkey homes from ₹14L for a 2BHK. Pricing is locked in writing before any work starts.",
  },
  {
    q: "How long does execution take?",
    a: "Factory manufacturing takes 18–25 days; site installation another 7–10 days. A typical 2BHK is move-in ready in 35–45 days, including civil work.",
  },
  {
    q: "Do you work outside Hubballi?",
    a: "Our factory and studio are in Hubballi, and we serve all of north Karnataka. For projects in Dharwad, Belagavi, Gadag and Haveri we deploy our own site team. Outside the region, we collaborate with vetted local installers.",
  },
  {
    q: "What warranty do I get?",
    a: "10 years on carcass and hardware, 5 years on lacquer, 2 years on installation. All in writing, transferable to a future owner.",
  },
];

const FAQ = () => {
  const [open, setOpen] = useState(0);
  return (
    <section
      id="faq"
      className="relative bg-[#F7F5F0] text-[#0A0A0A]"
      data-testid="faq-section"
    >
      <div className="mx-auto max-w-[1400px] px-6 py-20 md:px-12 md:py-32">
        <div className="grid items-end gap-6 md:grid-cols-12">
          <div className="md:col-span-7">
            <span className="text-[10px] uppercase tracking-[0.32em] text-[#0A0A0A]/55">07 · FAQ</span>
            <h2 className="mt-4 font-[Cormorant_Garamond] text-4xl font-light leading-[1.02] tracking-tight sm:text-5xl lg:text-6xl">
              Questions,<br /> <span className="italic text-[#B8996F]">honestly</span> answered.
            </h2>
          </div>
        </div>

        <div className="mt-12 border-t border-[#0A0A0A]/15">
          {FAQS.map((item, i) => {
            const isOpen = open === i;
            return (
              <div key={item.q} className="border-b border-[#0A0A0A]/15">
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  data-testid={`faq-item-${i}`}
                  className="flex w-full items-center justify-between gap-6 py-5 text-left"
                >
                  <span className="font-[Cormorant_Garamond] text-xl font-medium leading-snug md:text-2xl">
                    {item.q}
                  </span>
                  <span className="text-[#B8996F]">
                    {isOpen ? <Minus size={18} /> : <Plus size={18} />}
                  </span>
                </button>
                <div
                  className={`grid overflow-hidden font-[Outfit] text-sm leading-relaxed text-[#0A0A0A]/75 transition-all duration-500 ease-out ${
                    isOpen ? "grid-rows-[1fr] pb-6" : "grid-rows-[0fr]"
                  }`}
                >
                  <div className="overflow-hidden">{item.a}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
